import React from "react";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

const FormBlocContainer = ({displayCondition, cardStyle, cardClassName, title, isOptionalTitle, border, children, ...props}) => {

    return <React.Fragment>
        {
            (displayCondition === undefined || displayCondition === true) &&
            <Card style={cardStyle} className={border ? "card-border " + cardClassName : cardClassName}>
                {title && <CardHeader title={isOptionalTitle === true ? <React.Fragment>{title} <i>(facultatif)</i></React.Fragment> : title} />}
                {
                    children &&
                    <CardContent>
                        <Grid container >
                            {children}
                        </Grid>
                    </CardContent>

                }
            </Card>
        }
    </React.Fragment>
}

FormBlocContainer.propTypes = {
    title: PropTypes.string,
    isOptionalTitle: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string
}
export default FormBlocContainer;
